export default "__VITE_ASSET__DR$rSXJD__"